import * as styles from "./styles.module.scss"
import cx from "classnames"
import Link from "gatsby-link"
import * as React from "react"

export interface ListGroupProps {
  arrowSize?: string
  className?: string
  cta?: string
  invertColor?: boolean
}

const ListGroup: React.FC<ListGroupProps> = () => {
  return (
    <li className={styles.list}>
      <div className={styles.eyebrow} data-qa="about-us-link">
        <span className={styles.text}>About us</span>
      </div>
      <ul
        className={cx({
          [styles.subList]: true,
          [styles.expanded]: true,
        })}
      >
        <li className={styles.item} data-qa="about-us-company">
          <Link
            to="/about-us"
            className={styles.link}
            id="LinkTo-aboutUs-ourMission"
          >
            <span className={styles.text}>Our mission</span>
          </Link>
        </li>
        <li className={styles.item} data-qa="about-us-company">
          <Link
            to="/about-us/company"
            className={styles.link}
            id="LinkTo-aboutUs-company"
          >
            <span className={styles.text}>Company</span>
          </Link>
        </li>
        <li className={styles.item}>
          <Link
            to="/about-us/reviews"
            className={styles.link}
            id="LinkTo-aboutUs-reviews"
          >
            <span className={styles.text}>Reviews</span>
          </Link>
        </li>
        <li className={styles.item}>
          <Link
            to="/about-us/media"
            className={styles.link}
            id="LinkTo-aboutUs-media"
          >
            <span className={styles.text}>Media</span>
          </Link>
        </li>
        <li className={styles.item}>
          <Link
            to="/about-us/careers"
            className={styles.link}
            id="LinkTo-aboutUs-careers"
          >
            <span className={styles.text}>Careers</span>
          </Link>
        </li>
        <li className={styles.item}>
          <Link
            to="/about-us/contact-us"
            className={styles.link}
            id="LinkTo-aboutUs-contactUs"
          >
            <span className={styles.text}>Contact us</span>
          </Link>
        </li>
      </ul>
    </li>
  )
}

export default ListGroup
